type YourShiftsViewType = "YourShiftsView";
type TeamShiftsViewType = "TeamShiftsView";
export type EmployeeViewType = YourShiftsViewType | TeamShiftsViewType ;
export const EmployeeViewTypes = {
    YourShiftsView: "YourShiftsView" as EmployeeViewType,
    TeamShiftsView: "TeamShiftsView" as EmployeeViewType
};